import React, { Fragment, useState, useEffect } from "react";
import {
  Button,
  Container,
  TextField,
  Typography,
  Grid,
  Divider,
  IconButton,
} from "@mui/material";
import { Box } from "@mui/system";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import _ from "lodash";

const AddServiceAreaSideBar = ({ action, serviceAreas, zoomToServiceArea }) => {
  const [view, setView] = useState(false);
  const [formValues, setFormValues] = useState({
    name: {
      value: "",
      error: false,
      errorMessage: "You must enter a name",
    },
    description: {
      value: "",
      error: false,
      errorMessage: "You must enter description",
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleServiceAreaClick = (objectId) => {
    console.log("Zoom Click called...");
    zoomToServiceArea(objectId);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;

      if (currentValue === "") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
      }
    }

    setFormValues(newFormValues);
  };

  useEffect(() => {
    console.log("$$SA:", serviceAreas);
  }, []);

  useEffect(() => {
    console.log("$$SA2:", serviceAreas);
    // if (serviceAreas && serviceAreas.length > 0) {
    //   console.log("$$SA2 [0]:", serviceAreas[0]);
    //   console.log("$$SA2 [0]:", _.map(serviceAreas[0], "attributes"));
    //   console.log("$$SA2 [0]:", serviceAreas[0].geometry);
    // }
    if (serviceAreas && serviceAreas.length > 0) setView(() => true);
  }, [serviceAreas]);

  return (
    <Container type='form' noValidate onSubmit={handleSubmit}>
      {/* <Typography variant='body2' sx={{ mt: 2 }}>
        Please enter service area name:
      </Typography>

      <TextField
        placeholder='Enter Service Area name'
        name='name'
        variant='outlined'
        fullWidth
        required
        value={formValues.name.value}
        onChange={handleChange}
        error={formValues.name.error}
        helperText={formValues.name.error && formValues.name.errorMessage}
        sx={{
          padding: 2,
        }}
      />
      <Typography variant='body2'>Please enter description:</Typography>
      <TextField
        placeholder='Describe Service Area details'
        name='description'
        variant='outlined'
        fullWidth
        required
        value={formValues.description.value}
        multiline
        rows={4}
        onChange={handleChange}
        error={formValues.description.error}
        helperText={
          formValues.description.error && formValues.description.errorMessage
        }
        sx={{
          padding: 2,
        }}
      />
      <Box
        justifyContent='flex-end'
        display='flex'
        sx={{
          padding: 2,
        }}
      >
        <Button type='submit' variant='contained' color='secondary'>
          ADD
        </Button>
      </Box> */}
      <Grid sx={{ width: "250px" }}>
        <Box
          display='flex'
          flexDirection='row'
          justifyContent='space-evenly'
          // width={230}
          height={action === "config" ? 200 : 400}
          sx={{ margin: 1, backgroundColor: "lightgray" , overflow:"scroll" }}
        >
          <List
            sx={{ width: "100%", maxWidth: 360, backgroundColor: "lightgray" }}
          >
            {view &&
              serviceAreas &&
              serviceAreas.map((ele) => (
                <ListItem key={ele.OBJECTID}>
                  <ListItemButton
                    onClick={() => handleServiceAreaClick(ele.OBJECTID)}
                  >
                    <ListItemAvatar>
                      <Avatar>
                        <ImageIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={ele.Name}
                      secondary={ele.Description}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
          </List>
        </Box>
      </Grid>
      {/* <Button
          type='submit'
          variant='contained'
          color='primary'
          fullWidth
          sx={{ mt: 2, mr: 3, ml: 1, padding: 2 }}
        >
          {action === "config" ? "UPDATE" : "ADD TO PROJECT"}
        </Button> */}
    </Container>
  );
};

export default AddServiceAreaSideBar;
